"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinutesDifference = getMinutesDifference;
exports.isItemValid = exports.getStartedOn = void 0;
var _MediaPlayer = require("@studio/constants/MediaPlayer");
var _moment = _interopRequireDefault(require("moment"));
/**
 * Gets the time difference in minutes given two timestamps
 * @param {number} startTime
 * @param {number} finishTime
 */
function getMinutesDifference(startTime, finishTime) {
  var difference = Math.abs(finishTime - startTime);
  return Math.floor(difference / 1000 / 60); // milliseconds / seconds
}
var getStartedOn = exports.getStartedOn = function getStartedOn(isPlaying) {
  var serverTimeDelta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return isPlaying ? (0, _moment["default"])().utc().unix() - serverTimeDelta + _MediaPlayer.PLAY_DELAY : undefined;
};

/** Check that the item is not undefined or null */
var isItemValid = exports.isItemValid = function isItemValid(item) {
  return !!item;
};